export function isFirestorePermissionDenied(err) {
  const code = err?.code || "";
  if (code === "permission-denied") return true;
  return /missing or insufficient permissions/i.test(String(err?.message || ""));
}

/** Returns null for permission-denied load failures that should not alarm end users. */
export function userFacingLoadError(err, fallback) {
  if (isFirestorePermissionDenied(err)) return null;
  return err?.message || fallback;
}
